import React, { useState, useCallback, useRef, useEffect } from 'react';

import {
  Container,
  Content,
  ComboProps,
  ComboLocalServProps,
} from 'styles/sgo_wrappers';

import SGOHeader from 'components/SGOHeader';
import SGONavbar from 'components/SGONavbar';
import SGOFooter from 'components/SGOFooter';
import Loading from 'components/Loading';
import ScrollTop from 'components/ScrollTop';
import SelectV2 from 'components/SelectV2';
import InputDialog from 'components/InputDialog';

import { useAuth } from 'hooks/auth';
import { useCredentials } from 'hooks/credentials';
import { useToast } from 'hooks/toast';
import { useHistory, useLocation } from 'react-router-dom';

import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import api from 'services/api';
import Button from 'components/Button';
import { addDays, parseISO, subDays } from 'date-fns';
import getValidationErrors from 'utils/getValidationErrors';

import moment from 'moment';

import * as yup from 'yup';
import { addYears } from 'date-fns/esm';
import { formatDate } from 'utils/formatDate';
import { Grid, GridItem, StageBlock } from './styles';

import { DatesProps } from '../insert';
import { ListProps } from '../main';

interface FormData {
  e1lserv: string;
  e1dti: string;
  e1dtf: string;
  e1wd: string;
  e1hr: string;
  e1gap: string;
  e2lserv: string;
  e2dti: string;
  e2dtf: string;
  e2wd: string;
  e2hr: string;
  e2gap: string;
  e3dti: string;
  e3dtf: string;
  e3wd: string;
  e3hr: string;
  e3gap: string;
}

interface ComboGuias {
  seq: string;
  cert: string;
  nome: string;
  anb: string;
  loc: string;
  tg: string;
  func: string;
}

const EPGUpdate: React.FC = () => {
  const formRef = useRef<FormHandles>(null);
  const [loading, setLoading] = useState(false);

  const { user } = useAuth();
  const { errorHandling } = useCredentials();
  const { addToast } = useToast();
  const history = useHistory();
  const location = useLocation<ListProps>();

  const checkStageBlock = (date: string): boolean => {
    if (!location.state) {
      return true;
    }

    const epgDate = new Date(parseISO(date));
    const today = new Date(parseISO(new Date().toISOString()));

    const stageFinale = new Date(
      epgDate.getUTCFullYear(),
      epgDate.getUTCMonth(),
      epgDate.getUTCDate(),
      0,
      0,
    );
    const compare = new Date(
      today.getUTCFullYear(),
      today.getUTCMonth(),
      today.getUTCDate(),
      0,
      0,
    );

    const formats = 'YYYY-mm-dd';

    const finale = moment(stageFinale, formats);
    const base = moment(compare, formats);

    return base.isAfter(finale);
  };

  const hourValidation = (hour: string): boolean => {
    const hourstyle = 'hh:mm';

    const time = moment(hour, hourstyle);
    const init = moment('06:59', hourstyle);
    const finale = moment('22:01', hourstyle);

    return time.isBetween(init, finale);
  };

  const createDate = (date: string): Date => {
    const theDate = new Date(
      new Date(date).getUTCFullYear(),
      new Date(date).getUTCMonth(),
      new Date(date).getUTCDate(),
      0,
      0,
    );

    return theDate;
  };

  const checkGapE1F2 = useCallback(() => {
    const init1 = formRef.current?.getFieldValue('e1dti');
    const end2 = formRef.current?.getFieldValue('e2dtf');

    const formats = 'YYYY-mm-dd';

    const base = moment(createDate(end2), formats);
    const compare = moment(addDays(createDate(init1), 168), formats);

    return base.isSameOrBefore(compare);
  }, []);

  const checkGapF2E3 = useCallback(() => {
    const end2 = formRef.current?.getFieldValue('e2dtf');
    const init3 = formRef.current?.getFieldValue('e3dti');

    const formats = 'YYYY-mm-dd';

    const base = moment(createDate(init3), formats);
    const compare = moment(addDays(createDate(end2), 61), formats);

    return base.isSameOrBefore(compare);
  }, []);

  const [epg] = useState(() => {
    return location.state ? { ...location.state } : ({} as ListProps);
  });

  const [comboLServ, setComboLServ] = useState<ComboProps[]>([]);
  const [lserv1] = useState(() => (epg.pc1 ? epg.pc1.toString() : 'Selecione'));
  const [lserv2] = useState(() => (epg.pc2 ? epg.pc2.toString() : 'Selecione'));
  const [comboGuias, setComboGuias] = useState<ComboProps[]>([]);

  const [wd1] = useState(() => epg.wd1 || 'Selecione');
  const [wd2] = useState(() => epg.wd2 || 'Selecione');

  const [gap1] = useState(() => epg.ge1 || 'Selecione');
  const [gap2] = useState(() => epg.ge2 || 'Selecione');
  const [gap3] = useState(() => epg.ge3 || 'Selecione');
  const [df1] = useState(56);

  const [df2] = useState(105);
  const [df3] = useState(105);

  const [minDate] = useState(`${new Date().getUTCFullYear()}-01-01`);
  const [maxDate] = useState(`${new Date().getUTCFullYear() + 1}-12-31`);

  const [blockStage1] = useState(() => {
    return checkStageBlock(epg.dtf1);
  });

  const [blockStage2] = useState(() => {
    return checkStageBlock(epg.dtf2);
  });

  const [blockStage3] = useState(() => {
    return checkStageBlock(epg.dtf3);
  });

  const [rangeDF1] = useState<{ min: number; max: number }>({
    min: df1 - 10,
    max: df1 + 10,
    // min: df1 - 30,
    // max: df1 + 30,
  });
  const [rangeDF2] = useState<{ min: number; max: number }>({
    min: df2 - 10,
    max: df2 + 10,
    // min: df2 - 30,
    // max: df2 + 30,
  });
  const [rangeDF3] = useState<{ min: number; max: number }>({
    min: df3 - 10,
    max: df3 + 10,
    // min: df3 - 35,
    // max: df3 + 35,
  });

  const semana: ComboProps[] = [
    { value: '1', label: 'Segunda' },
    { value: '2', label: 'Terça' },
    { value: '3', label: 'Quarta' },
    { value: '4', label: 'Quinta' },
    { value: '5', label: 'Sexta' },
    { value: '6', label: 'Sábado' },
    { value: '0', label: 'Domingo' },
  ];

  const getGuias = useCallback(async () => {
    const response = await api.get(
      `/combos/comboGuias.php?data=${JSON.stringify({ filter: 'byLoc' })}`,
    );

    setComboGuias(
      response.data
        .filter(
          (item: ComboGuias) =>
            item.loc === user.loccod && ['GA', 'GP'].indexOf(item.tg) > -1,
        )
        .map((item: ComboGuias) => ({ label: item.nome, value: item.seq })),
    );
  }, [user.loccod]);

  const getLocalServ = useCallback(async () => {
    try {
      const response = await api.get(`/combos/comboLocalServ.php`);
      setComboLServ(
        response.data.map((item: ComboLocalServProps) => ({
          value: item.cod,
          label: `${item.nome}, ${item.cid}`,
        })),
      );
    } catch (err) {
      errorHandling(err);
    }
  }, [errorHandling]);

  useEffect(() => {
    if (!location.state) {
      history.goBack();
      return;
    }
    getLocalServ();
    if (user.perfil === 'LOC') {
      getGuias();
    }
  }, [getGuias, getLocalServ, history, location.state, user.perfil]);

  const handleSubmit = useCallback(
    async (data: FormData) => {
      try {
        setLoading(true);

        formRef.current?.setErrors({});
        const schemaValidateDate = yup.object().shape({
          e1dti: yup.date().typeError('Data inválida.'),
          e2dti: yup.date().typeError('Data inválida.'),
          e3dti: yup.date().typeError('Data inválida.'),
        });

        await schemaValidateDate.validate(data, {
          abortEarly: false,
        });

        const iniE1 = createDate(formRef.current?.getFieldValue('e1dti'));
        const iniE2 = createDate(formRef.current?.getFieldValue('e2dti'));
        const iniE3 = createDate(formRef.current?.getFieldValue('e3dti'));
        const min = createDate(minDate);
        const max = createDate(maxDate);

        // const currYear = new Date().getFullYear();

        // const minDate = new Date(currYear, 0, 1, 0, 0);
        // const maxDate = new Date(currYear + 1, 11, 31, 0, 0);

        const validYear = yup.object().shape({
          e1dti: yup
            .date()
            .min(
              min,
              `Data de início deve ser posterior à ${formatDate(
                subDays(min, 1).toISOString(),
              )}`,
            )
            .max(
              max,
              `Data de início deve ser anterior à ${formatDate(
                addYears(max, 1).toISOString(),
              )}`,
            ),
          e2dti: yup
            .date()
            .min(
              min,
              `Data de início deve ser posterior à ${formatDate(
                subDays(min, 1).toISOString(),
              )}`,
            )
            .max(
              max,
              `Data de início deve ser anterior à ${formatDate(
                addDays(max, 1).toISOString(),
              )}`,
            ),
          e3dti: yup
            .date()
            .min(
              min,
              `Data de início deve ser posterior à ${formatDate(
                subDays(min, 1).toISOString(),
              )}`,
            )
            .max(
              iniE1.getUTCFullYear() > min.getUTCFullYear()
                ? addYears(max, 1)
                : max,
              `Data de início deve ser anterior à ${formatDate(
                addDays(
                  iniE1.getUTCFullYear() > min.getUTCFullYear()
                    ? addYears(max, 1)
                    : max,
                  1,
                ).toISOString(),
              )}`,
            ),
        });

        await validYear.validate(data, {
          abortEarly: false,
        });

        const semE1 = iniE1.getMonth() < 6 ? 1 : 2;
        const semE2 = iniE2.getMonth() < 6 ? 1 : 2;
        const semE3 = iniE3.getMonth() < 6 ? 1 : 2;

        const dates: DatesProps = {
          minINIe1:
            semE1 === 1
              ? new Date(iniE1.getFullYear(), 0, 2, 0, 0)
              : new Date(iniE1.getFullYear(), 6, 1, 0, 0),
          maxINIe1:
            semE1 === 1
              ? new Date(iniE1.getFullYear(), 0, 10, 0, 0)
              : new Date(iniE1.getFullYear(), 6, 5, 0, 0),
          minINIe2:
            semE2 === 1
              ? new Date(iniE2.getFullYear(), 2, 5, 0, 0)
              : new Date(iniE2.getFullYear(), 8, 2, 0, 0),
          maxINIe2:
            semE2 === 1
              ? new Date(iniE2.getFullYear(), 2, 15, 0, 0)
              : new Date(iniE2.getFullYear(), 8, 5, 0, 0),
          minINIe3:
            semE3 === 1
              ? new Date(iniE3.getFullYear(), 0, 2, 0, 0)
              : new Date(iniE3.getFullYear(), 6, 1, 0, 0),
          maxINIe3:
            semE3 === 1
              ? new Date(iniE3.getFullYear(), 1, 15, 0, 0)
              : new Date(iniE3.getFullYear(), 7, 10, 0, 0),
        };

        const s1di = iniE1;

        const s2di = iniE2;

        const s3di = iniE3;

        const schema = yup.object().shape({
          e1lserv: yup.string().notOneOf(['Selecione', '']),
          e1dti: yup
            .date()
            .typeError('Data inválida.')
            .min(
              dates.minINIe1,
              `Data de início deve ser posterior à ${formatDate(
                subDays(dates.minINIe1, 1).toISOString(),
              )}`,
            )
            .max(
              dates.maxINIe1,
              `Data de início deve ser anterior à ${formatDate(
                addDays(dates.maxINIe1, 1).toISOString(),
              )}`,
            ),
          e1dtf: yup
            .date()
            .typeError('Data inválida.')
            .min(
              addDays(s1di, rangeDF1.min),
              `Data mínima permitida: ${formatDate(
                addDays(s1di, rangeDF1.min).toISOString(),
              )}`,
            )
            .max(
              addDays(s1di, rangeDF1.max),
              `Data máxima permitida: ${formatDate(
                addDays(s1di, rangeDF1.max).toISOString(),
              )}`,
            ),
          e1wd: yup.string().notOneOf(['Selecione', '']),
          e1hr: yup.lazy((val) =>
            val
              ? yup
                  .string()
                  .test(
                    'hour1',
                    'Horário deve ser entre 07h00 e 22h00',
                    (hour: string) => {
                      return hourValidation(hour);
                    },
                  )
              : yup.string().required('Campo obrigatório'),
          ),
          e1gap: yup.string().notOneOf(['Selecione', '']),
          e2lserv: yup.string().notOneOf(['Selecione', '']),
          e2dti: yup
            .date()
            .typeError('Data inválida.')
            .min(
              dates.minINIe2,
              `Data mínima permitida: ${formatDate(
                dates.minINIe2.toISOString(),
              )}`,
            )
            .max(
              dates.maxINIe2,
              `Data inicial deve ser anterior à ${formatDate(
                addDays(dates.maxINIe2, 1).toISOString(),
              )}`,
            ),
          e2dtf: yup
            .date()
            .typeError('Data inválida.')
            .test(
              'maxENDet2',
              'Limite entre período de etapas excedido.',
              checkGapE1F2,
            )
            .min(
              addDays(s2di, rangeDF2.min),
              // addDays(s2di, rangeDF2.min),
              `Data mínima permitida: ${formatDate(
                addDays(s2di, rangeDF2.min).toISOString(),
              )}`,
            )
            .max(
              addDays(s2di, rangeDF2.max),
              `Data máxima permitida: ${formatDate(
                addDays(s2di, rangeDF2.max).toISOString(),
              )}`,
            ),
          e2wd: yup.string().notOneOf(['Selecione', '']),
          e2hr: yup.lazy((val) =>
            val
              ? yup
                  .string()
                  .test(
                    'hour2',
                    'Horário deve ser entre 07h00 e 22h00',
                    (hour: string) => {
                      return hourValidation(hour);
                    },
                  )
              : yup.string().required('Campo obrigatório'),
          ),
          e2gap: yup.string().notOneOf(['Selecione', '']),
          e3dti: yup
            .date()
            .typeError('Data inválida.')
            .test(
              'minIniET3',
              'Limite entre período de etapas excedido.',
              checkGapF2E3,
            )
            .min(
              dates.minINIe3,
              `Data mínima permitida: ${formatDate(
                dates.minINIe3.toISOString(),
              )}`,
            )
            .max(
              dates.maxINIe3,
              `Data inicial deve ser anterior à ${formatDate(
                addDays(dates.maxINIe3, 1).toISOString(),
              )}`,
            ),
          e3dtf: yup
            .date()
            .typeError('Data inválida.')
            .min(
              addDays(s3di, rangeDF3.min),
              // addDays(s3di, rangeDF3.min),
              `Data mínima permitida: ${formatDate(
                addDays(s3di, rangeDF3.min).toISOString(),
              )}`,
            )
            .max(
              addDays(s3di, rangeDF3.max),
              `Data máxima permitida: ${formatDate(
                addDays(s3di, rangeDF3.max).toISOString(),
              )}`,
            ),
          e3gap: yup.string().notOneOf(['Selecione', '']),
        });

        await schema.validate(data, {
          abortEarly: false,
        });

        const send = new FormData();
        send.append('data', JSON.stringify({ epg: epg.epg, ...data }));

        await api.post('/sgo/epg_update.php', send, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });

        addToast({
          type: 'success',
          title: 'Sucesso!',
          description: 'EPG alterada',
        });

        history.goBack();
        setLoading(false);
      } catch (err) {
        setLoading(false);
        if (err instanceof yup.ValidationError) {
          const errors = getValidationErrors(err);

          formRef.current?.setErrors(errors);
          return;
        }
        errorHandling(err);
      }
    },
    [
      addToast,
      checkGapE1F2,
      checkGapF2E3,
      epg.epg,
      errorHandling,
      history,
      maxDate,
      minDate,
      rangeDF1.max,
      rangeDF1.min,
      rangeDF2.max,
      rangeDF2.min,
      rangeDF3.max,
      rangeDF3.min,
    ],
  );

  return (
    <Container>
      <Loading isLoading={loading} />
      <ScrollTop />
      <SGOHeader />
      <SGONavbar noLinks title={epg.epg ? `EPG E-${epg.epg}` : ''} />
      <Content>
        <Form
          ref={formRef}
          onSubmit={handleSubmit}
          initialData={{
            e1lserv: epg.pc1 && epg.pc1.toString(),
            e1dti: epg.dti1,
            e1dtf: epg.dtf1,
            e1wd: epg.wd1,
            e1hr: epg.hr1,
            e1gap: epg.ge1,
            e2lserv: epg.pc2 && epg.pc2.toString(),
            e2dti: epg.dti2,
            e2dtf: epg.dtf2,
            e2wd: epg.wd2,
            e2hr: epg.hr2,
            e2gap: epg.ge2,
            e3dti: epg.dti3,
            e3dtf: epg.dtf3,
            e3gap: epg.ge3,
          }}
        >
          <Grid>
            <GridItem blocked={blockStage1} delay={0.35}>
              <h2>1ª Etapa</h2>
              <div>
                {(blockStage1 || !!epg.sit) && (
                  <StageBlock
                    banner={epg.sit === 'F' ? '#c53030' : ''}
                    textcolor={epg.sit === 'F' ? '#fff' : ''}
                  >
                    <p>{epg.sit === 'F' ? 'Encerrada' : 'Finalizada'}</p>
                  </StageBlock>
                )}
                <div>
                  <span>
                    <p>Local de Serviço/Atividade</p>
                    <SelectV2
                      name="e1lserv"
                      content={comboLServ}
                      initial={lserv1}
                    />
                  </span>
                </div>
                <div>
                  <span>
                    <p>Data de Início</p>
                    <InputDialog
                      onClick={() =>
                        formRef.current?.setFieldError('e1dti', '')
                      }
                      containerStyle={{
                        width: '172.5px',
                        padding: '5px 2px 4.82px 5px',
                      }}
                      inputStyle={{
                        width: '110px',
                      }}
                      type="date"
                      placeholder="dd/mm/aaaa"
                      name="e1dti"
                      // onBlur={handleDI1}
                    />
                  </span>
                  <span>
                    <p>Data Final</p>
                    <InputDialog
                      onClick={() =>
                        formRef.current?.setFieldError('e1dtf', '')
                      }
                      containerStyle={{
                        width: '172.5px',
                        padding: '5px 2px 4.82px 5px',
                      }}
                      inputStyle={{
                        width: '110px',
                      }}
                      type="date"
                      placeholder="dd/mm/aaaa"
                      name="e1dtf"
                      // onBlur={handleDF1}
                    />
                  </span>
                </div>
                <div>
                  <span>
                    <p>Dia da Semana</p>
                    <SelectV2
                      name="e1wd"
                      content={semana}
                      containerStyle={{
                        width: '172.5px',
                        height: '37.5px',
                      }}
                      initial={wd1}
                    />
                  </span>
                  <span>
                    <p>Horário</p>
                    <InputDialog
                      type="time"
                      containerStyle={{
                        width: '172.5px',
                        padding: '5px 2px 4.82px 5px',
                      }}
                      inputStyle={{
                        width: '110px',
                      }}
                      name="e1hr"
                      placeholder="--:--"
                    />
                  </span>
                </div>

                <div>
                  <span>
                    <p>Guia Aplicador</p>
                    {user.perfil !== 'LOC' ? (
                      <>
                        <InputDialog isHidden name="e1gap" />
                        <h3>{user.name}</h3>
                      </>
                    ) : (
                      <SelectV2
                        name="e1gap"
                        content={comboGuias}
                        initial={gap1}
                        // onChange={handleGuiaE1}
                      />
                    )}
                  </span>
                </div>
              </div>
            </GridItem>
            <GridItem blocked={blockStage2} delay={0.7}>
              <h2>2ª Etapa</h2>
              <div>
                {(blockStage2 || !!epg.sit) && (
                  <StageBlock
                    banner={epg.sit === 'F' ? '#c53030' : ''}
                    textcolor={epg.sit === 'F' ? '#fff' : ''}
                  >
                    <p>{epg.sit === 'F' ? 'Encerrada' : 'Finalizada'}</p>
                  </StageBlock>
                )}
                <div>
                  <span>
                    <p>Local de Serviço/Atividade</p>
                    <SelectV2
                      name="e2lserv"
                      content={comboLServ}
                      initial={lserv2}
                    />
                  </span>
                </div>
                <div>
                  <span>
                    <p>Data de Início</p>
                    <InputDialog
                      onClick={() =>
                        formRef.current?.setFieldError('e2dti', '')
                      }
                      containerStyle={{
                        width: '172.5px',
                        padding: '5px 2px 4.82px 5px',
                      }}
                      inputStyle={{
                        width: '110px',
                      }}
                      type="date"
                      placeholder="dd/mm/aaaa"
                      name="e2dti"
                      // onBlur={handleDI2}
                    />
                  </span>
                  <span>
                    <p>Data Final</p>
                    <InputDialog
                      onClick={() =>
                        formRef.current?.setFieldError('e2dtf', '')
                      }
                      containerStyle={{
                        width: '172.5px',
                        padding: '5px 2px 4.82px 5px',
                      }}
                      inputStyle={{
                        width: '110px',
                      }}
                      type="date"
                      placeholder="dd/mm/aaaa"
                      name="e2dtf"
                      // onBlur={handleDF2}
                    />
                  </span>
                </div>
                <div>
                  <span>
                    <p>Dia da Semana</p>
                    <SelectV2
                      name="e2wd"
                      content={semana}
                      containerStyle={{
                        width: '172.5px',
                        height: '37.5px',
                      }}
                      initial={wd2}
                    />
                  </span>
                  <span>
                    <p>Horário</p>
                    <InputDialog
                      type="time"
                      placeholder="--:--"
                      containerStyle={{
                        width: '172.5px',
                        padding: '5px 2px 4.82px 5px',
                      }}
                      inputStyle={{
                        width: '110px',
                      }}
                      name="e2hr"
                      // onBlur={handleHR2}
                    />
                  </span>
                </div>

                <div>
                  <span>
                    <p>Guia Aplicador</p>
                    {user.perfil !== 'LOC' ? (
                      <>
                        <InputDialog isHidden name="e2gap" />
                        <h3>{user.name}</h3>
                      </>
                    ) : (
                      <SelectV2
                        name="e2gap"
                        content={comboGuias}
                        initial={gap2}
                        // onChange={handleGuiaE2}
                      />
                    )}
                  </span>
                </div>
              </div>
            </GridItem>
            <GridItem blocked={blockStage3} delay={1.05}>
              <h2>3ª Etapa</h2>
              <div>
                {(blockStage3 || !!epg.sit) && (
                  <StageBlock
                    banner={epg.sit === 'F' ? '#c53030' : ''}
                    textcolor={epg.sit === 'F' ? '#fff' : ''}
                  >
                    <p>{epg.sit === 'F' ? 'Encerrada' : 'Finalizada'}</p>
                  </StageBlock>
                )}
                {/* {blockStage3 && (
                  <StageBlock>
                    <p>Finalizada</p>
                  </StageBlock>
                )} */}
                <div>
                  <span>
                    <h2>Oficina Supervisionada</h2>
                  </span>
                </div>
                <div>
                  <span>
                    <p>Data de Início</p>
                    <InputDialog
                      onClick={() =>
                        formRef.current?.setFieldError('e3dti', '')
                      }
                      containerStyle={{
                        width: '172.5px',
                        padding: '5px 2px 4.82px 5px',
                      }}
                      inputStyle={{
                        width: '110px',
                      }}
                      type="date"
                      placeholder="dd/mm/aaaa"
                      name="e3dti"
                      // onBlur={handleDI3}
                    />
                  </span>
                  <span>
                    <p>Data Final</p>
                    <InputDialog
                      onClick={() =>
                        formRef.current?.setFieldError('e3dtf', '')
                      }
                      containerStyle={{
                        width: '172.5px',
                        padding: '5px 2px 4.82px 5px',
                      }}
                      inputStyle={{
                        width: '110px',
                      }}
                      type="date"
                      placeholder="dd/mm/aaaa"
                      name="e3dtf"
                      // onBlur={handleDF3}
                    />
                  </span>
                </div>
                <div>
                  <span style={{ opacity: 0, pointerEvents: 'none' }}>
                    <p>Dia da Semana</p>
                    <SelectV2
                      name="e3wd"
                      content={[]}
                      containerStyle={{
                        width: '172.5px',
                        height: '37.5px',
                      }}
                    />
                  </span>
                  <span style={{ opacity: 0, pointerEvents: 'none' }}>
                    <p>Horário</p>
                    <InputDialog
                      type="time"
                      containerStyle={{
                        width: '172.5px',
                        padding: '5px 2px 4.82px 5px',
                      }}
                      inputStyle={{
                        width: '110px',
                      }}
                      name="e3hr"
                    />
                  </span>
                </div>

                <div>
                  <span>
                    <p>Guia Aplicador</p>
                    {user.perfil !== 'LOC' ? (
                      <>
                        <InputDialog isHidden name="e3gap" />
                        <h3>{user.name}</h3>
                      </>
                    ) : (
                      <SelectV2
                        name="e3gap"
                        content={comboGuias}
                        initial={gap3}
                      />
                    )}
                  </span>
                </div>
              </div>
            </GridItem>
          </Grid>
          {!blockStage3 && (
            <Button bgcolor="#00802b" type="submit" animated delay={1.5}>
              Finalizar
            </Button>
          )}
        </Form>
      </Content>
      <SGOFooter />
    </Container>
  );
};

export default EPGUpdate;
